import { render } from "./index.vue?vue&type=template&id=5b9dcd6d&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5b9dcd6d&scoped=true&lang=scss"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9dcd6d"]])

export default __exports__